import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=16dd6633&scoped=true"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"
import style0 from "./AddButton.vue?vue&type=style&index=0&id=16dd6633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd6633",
  null
  
)

export default component.exports